import { isValidLink as e } from "../../shared/isValidLink.es.js";
import { useState as t } from "react";
import { jsx as n } from "react/jsx-runtime";
// lib/Link/components/Link.tsx
var r = ({ children: r, element: i }) => {
	let a = i.properties?.url || "", [o, s] = t(!1);
	return /* @__PURE__ */ n("a", {
		className: `underline decoration-2 underline-offset-4 ${e(a) ? "decoration-blue-300" : "decoration-wavy decoration-red-400"}`,
		href: a,
		onClick: (e) => {
			e.preventDefault(), window.open(a, "_blank", "noopener,noreferrer");
		},
		onMouseEnter: () => {
			s(!0);
		},
		onMouseLeave: () => {
			s(!1);
		},
		title: `${i.properties?.title || ""}`,
		style: {
			textDecorationStyle: e(a) ? "solid" : "wavy",
			cursor: o ? "pointer" : "auto"
		},
		children: r
	});
};
export { r as Link };
